import { render, staticRenderFns } from "./ListAssignments.vue?vue&type=template&id=78971022&"
import script from "./ListAssignments.vue?vue&type=script&lang=js&"
export * from "./ListAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports